import React, { useState } from 'react';

const SearchResultItem = ({ result }) => {
    const [expanded, setExpanded] = useState(false);
    const isLink = result.url !== '#';

    const Wrapper = isLink ? 'a' : 'div';
    const wrapperProps = isLink
        ? { href: result.url, target: "_blank", rel: "noopener noreferrer" }
        : { onClick: () => setExpanded(!expanded) };

    return (
        <Wrapper
            {...wrapperProps}
            className={`flex flex-col p-6 bg-white rounded-2xl border transition-all duration-300 cursor-pointer ${expanded
                ? 'border-primary-500 shadow-xl scale-[1.02]'
                : (isLink ? 'border-slate-200 shadow-sm hover:border-primary-400 hover:shadow-lg hover:-translate-y-1' : 'border-primary-100 shadow-sm border-l-4 border-l-primary-500 hover:border-primary-300 hover:shadow-md')
                }`}
        >
            <div className="flex flex-col h-full">
                <div className="flex items-start justify-between mb-5">
                    <span className="inline-block px-3 py-1 bg-slate-100 text-slate-600 text-[9px] font-black uppercase tracking-widest rounded-lg border border-slate-200/50">
                        {result.categoryName}
                    </span>
                    {isLink ? (
                        <div className="p-1.5 bg-slate-50 rounded-lg group-hover:bg-primary-50 transition-colors">
                            <svg className="w-5 h-5 text-slate-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                            </svg>
                        </div>
                    ) : (
                        <div className={`p-1.5 rounded-lg transition-colors ${expanded ? 'bg-primary-100 text-primary-600' : 'bg-slate-50 text-slate-400'}`}>
                            <svg className={`w-5 h-5 transition-transform duration-500 ${expanded ? 'rotate-180' : ''}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M19 9l-7 7-7-7" />
                            </svg>
                        </div>
                    )}
                </div>

                <h4 className={`font-black text-xl leading-tight mb-4 transition-colors ${expanded || !isLink ? 'text-primary-900' : 'text-slate-800'}`}>
                    {result.title}
                </h4>

                {result.text && (!isLink && !expanded ? null : (
                    <div className={`mt-3 animate-fade-in ${!isLink && expanded ? 'p-6 bg-primary-50/30 rounded-2xl border border-primary-100/50' : 'text-slate-600'}`}>
                        <p className="text-base md:text-lg font-normal leading-relaxed whitespace-pre-wrap">
                            {result.text}
                        </p>

                        {expanded && result.actions && result.actions.length > 0 && (
                            <div className="flex flex-col gap-3 mt-6">
                                {result.actions.map((action, idx) => (
                                    <a
                                        key={idx}
                                        href={action.url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className={`inline-flex items-center justify-center w-full px-6 py-3 font-bold rounded-xl transition-all duration-200 hover:shadow-md hover:-translate-y-0.5 text-sm ${action.type === 'whatsapp'
                                            ? 'bg-[#25D366] text-white hover:bg-[#128C7E]'
                                            : 'bg-primary-600 text-white hover:bg-primary-700'
                                            }`}
                                    >
                                        {action.label}
                                        <svg className="w-4 h-4 ml-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                                        </svg>
                                    </a>
                                ))}
                            </div>
                        )}
                    </div>
                ))}

                {!isLink && !expanded && result.text && (
                    <div className="mt-auto pt-6 flex items-center text-[10px] font-black text-primary-600 uppercase tracking-widest">
                        Click para más info
                        <svg className="w-4 h-4 ml-2 animate-bounce-y" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M19 9l-7 7-7-7" />
                        </svg>
                    </div>
                )}

                {isLink && (
                    <div className="mt-auto pt-6 flex items-center text-[10px] font-black text-slate-400 uppercase tracking-widest group-hover:text-primary-600 transition-colors">
                        Acceder al sitio
                        <svg className="w-4 h-4 ml-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                        </svg>
                    </div>
                )}
            </div>
        </Wrapper>
    );
};

export default SearchResultItem;
